import React, { Component } from 'react';
import { Col, Form, Input, Select, Divider } from 'antd';
import { BANK_NAMES } from '../../../constants/bank.js.erb';

const { Option } = Select;

class DebtInfoAttributes extends Component {
  render () {
    return (
      <>
        <Col span={24}>
          <Divider orientation="left">Información de la deuda</Divider>
        </Col>
        <Form.Item label="ID" name={['debtInfoAttributes', 'id']} hidden>
          <Input/>
        </Form.Item>
        <Col span={6}>
          <Form.Item label="Institución" name={['debtInfoAttributes', 'bankName']}>
            <Select placeholder="Seleccione Banco">
              {
                BANK_NAMES.map((bank) => (
                  <Option value={bank} key={`debt-${bank}`}>{bank}</Option>
                ))
              }
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Nombre ejecutivo" name={['debtInfoAttributes', 'agentName']}>
            <Input/>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Teléfono" name={['debtInfoAttributes', 'agentPhoneNumber']}>
            <Input/>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Email" name={['debtInfoAttributes', 'agentEmail']}>
            <Input/>
          </Form.Item>
        </Col>
      </>
    );
  }
}

export default DebtInfoAttributes;
